import React, { useState, useMemo, useRef } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";

import { databaseUrl } from "../../server/server";
import axiosInstance from "../../server/axios";
import Button from '@mui/material/Button';


// --- 핵심 모듈 import ---
//import ImageUploader from "quill-image-uploader";
import ImageResize from "quill-image-resize-module-react";

// --- Quill 에 모듈 등록 ---
//Quill.register("modules/imageUploader", ImageUploader);
Quill.register("modules/imageResize", ImageResize);

const TextEditor = ({data,value,onChange}) => {
  /*
    api:'/orderboards/memo',
    sendbutton:'메모변경',
    contents:'loading...'
  */

  //const [value, setValue] = useState(data.contents);
  const [sendName, setSendName] = useState(data.sendbutton);
  const [api,setApi] = useState(data.api);
  const quillRef = useRef(null);


  const changeContents = () => {
        if(window.confirm("메모 내용 변경?")){
          console.log(`${databaseUrl}${api}`);
          const contents = axiosInstance.post(`${databaseUrl}${api}`,{
            contents:value
          })
          alert("changed");
        }
      }
  // --- modules 설정 ---
  const modules = useMemo(
    () => ({
      toolbar: [
        [{ header: [1, 2, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ color: [] }, { background: [] }],
        ["image"],
        ["clean"],
      ],
      imageResize: {
        parchment: Quill.import("parchment"),
        modules: ["Resize", "DisplaySize", "Toolbar"],
      },
    }),
    []
  );
  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "image",
    "color",
    "background",
  ];
  return (
    <div style={{ width: "400px" }}>
      <ReactQuill
        ref={quillRef}
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
      />
      글자수: {value.length}
      <br></br>
      <Button 
            variant="outlined" 
            color="primary"
            onClick={()=>changeContents()}
      >
      {sendName}
      </Button>
    </div>
  );
};
export default TextEditor;